import { AutoText } from "./Field";

const SIGN = [["prepared", "Disediakan oleh:"], ["reviewed", "Disemak oleh:"], ["approved", "Disahkan oleh:"]];

export const SignatoriesEditor = ({ signatories = {}, onChange, canWrite }) => (
  <div className="grid gap-6 sm:grid-cols-3" data-testid="official-signatories">
    {SIGN.map(([k, label]) => {
      const p = signatories[k] || { name: "", position: "" };
      const set = (patch) => onChange({ ...signatories, [k]: { ...p, ...patch } });
      return (
        <div key={k} data-testid={`signatory-${k}`}>
          <p>{label}</p>
          <p className="mt-8 tracking-widest text-slate-400">........................................</p>
          <AutoText value={p.name} bold disabled={!canWrite} onChange={(v) => set({ name: v })} placeholder="NAMA" className="uppercase" testId={`signatory-${k}-name`} />
          <AutoText value={p.position} disabled={!canWrite} onChange={(v) => set({ position: v })} placeholder="Jawatan&#10;Jabatan / Agensi" className="text-sm" testId={`signatory-${k}-position`} />
        </div>
      );
    })}
  </div>
);
